'use client';

import { useEffect, useState } from 'react';

export function useIsCompactCartLayout(breakpoint = 850) {
  const [isCompactCartLayout, setIsCompactCartLayout] = useState(false);

  useEffect(() => {
    const update = () => {
      setIsCompactCartLayout(window.innerWidth < breakpoint);
    };

    update();
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);

    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, [breakpoint]);

  return isCompactCartLayout;
}
